const STORAGE_KEY = 'wedding_rsvp_confirmation';

export const saveConfirmation = (fingerprint, data) => {
  try {
    const confirmations = getConfirmations();
    confirmations[fingerprint] = {
      ...data,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(confirmations));
    return true;
  } catch (error) {
    console.error('Error saving confirmation:', error);
    return false;
  }
};

export const getConfirmation = (fingerprint) => {
  try {
    const confirmations = getConfirmations();
    return confirmations[fingerprint] || null;
  } catch (error) {
    console.error('Error getting confirmation:', error);
    return null;
  }
};

export const getConfirmations = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error('Error reading confirmations:', error);
    return {};
  }
};

export const clearConfirmation = (fingerprint) => {
  try {
    const confirmations = getConfirmations();
    delete confirmations[fingerprint];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(confirmations));
    return true;
  } catch (error) {
    console.error('Error clearing confirmation:', error);
    return false;
  }
};
